// extracted by mini-css-extract-plugin
export default {"container":"ScreenSizeModal_container__eB0oE","image":"ScreenSizeModal_image__JBIAT"};